import React from 'react';
import { MessageSquare, FileText, Star } from 'lucide-react';

export default function ReportTabs({ activeTab, onTabChange }) {
  const tabs = [
    {
      id: 'reports',
      label: 'Phản ánh',
      icon: MessageSquare
    },
    {
      id: 'news',
      label: 'Tin tức',
      icon: FileText
    },
    {
      id: 'procedures',
      label: 'Thủ tục hành chính',
      icon: FileText
    },
    {
      id: 'feedback',
      label: 'Đánh giá',
      icon: Star
    }
  ];

  return (
    <div className="mb-4">
      <div className="grid grid-cols-2 sm:flex sm:flex-row gap-1.5 sm:gap-1 bg-gray-100 p-1.5 sm:p-1 rounded-xl sm:rounded-lg">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-md font-medium text-xs sm:text-sm whitespace-nowrap transition-all duration-200 sm:flex-1 justify-center cursor-pointer ${
                isActive
                  ? 'bg-white text-gray-900 shadow-sm font-semibold'
                  : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50/80'
              }`}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
